module.exports = __webpack_public_path__ + "img/logo-moonstake-white.f42e91c3.svg";